import React from 'react'
import { IProviderSummary } from '../../core/types'

interface Props {
  summary: IProviderSummary | null
  isLoading: boolean
}

const SummaryValue: React.FC<{ value: React.ReactNode; isLoading: boolean }> = ({ value, isLoading }) => {
  if (isLoading) {
    return <span className='spinner-border spinner-border-sm align-middle' />
  }

  return <>{value}</>
}

export default ({ summary, isLoading }: Props) => {
  return (
    <div className='row g-5 g-xl-8 mb-7'>
      <div className='col-xl-3'>
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-body'>
            <div className='text-gray-900 fw-bold fs-6 mb-2'>Состояние сервиса</div>
            <div className='fs-2hx fw-bold'>
              <SummaryValue
                isLoading={isLoading}
                value={
                  summary?.serviceAvailable
                    ? <span className='text-success'>Доступен</span>
                    : <span className='text-danger'>Недоступен</span>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-body'>
            <div className='text-gray-900 fw-bold fs-6 mb-2'>Провайдеры</div>
            <div className='fs-2hx fw-bold mb-2'>
              <SummaryValue isLoading={isLoading} value={summary?.providersCount ?? 0} />
            </div>
            <div className='text-muted fs-7'>
              Включено: <strong className='text-success'>{isLoading ? '...' : summary?.enabledProvidersCount ?? 0}</strong>
            </div>
            <div className='text-muted fs-7'>
              Выключено: <strong className='text-danger'>{isLoading ? '...' : summary?.disabledProvidersCount ?? 0}</strong>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-body'>
            <div className='text-gray-900 fw-bold fs-6 mb-2'>Транзакции в работе</div>
            <div className='fs-2hx fw-bold mb-3'>
              <SummaryValue isLoading={isLoading} value={summary?.transactionsInProgress.total ?? 0} />
            </div>
            <div className='text-muted fs-7'>
              Пополнения: <strong>{isLoading ? '...' : summary?.transactionsInProgress.deposit ?? 0}</strong>
            </div>
            <div className='text-muted fs-7'>
              Выплаты: <strong>{isLoading ? '...' : summary?.transactionsInProgress.payout ?? 0}</strong>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-body'>
            <div className='text-gray-900 fw-bold fs-6 mb-2'>Credential-связок</div>
            <div className='fs-2hx fw-bold'>
              <SummaryValue isLoading={isLoading} value={summary?.credentialsCount ?? 0} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
